import { useState } from "react";
import { Button, Label, Modal, TextInput } from "flowbite-react";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { useTranslation } from "react-i18next";

interface ClientPasswordDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (password: string) => void;
  isLoading?: boolean;
}

export default function ClientPasswordDialog({
  open,
  onClose,
  onSubmit,
  isLoading,
}: ClientPasswordDialogProps) {
  const { t } = useTranslation(["client", "common"]);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!password.trim()) {
      setError(t("client:passwordRequired"));
      return;
    }
    setError("");
    onSubmit(password);
  };

  const handleClose = () => {
    setPassword("");
    setError("");
    onClose();
  };

  return (
    <Modal show={open} onClose={handleClose} size="md">
      <Modal.Header>{t("client:setPassword")}</Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <div className="mb-2 block">
              <Label htmlFor="client_password" value={t("client:password")} />
            </div>
            <div className="relative">
              <TextInput
                id="client_password"
                type={showPassword ? "text" : "password"}
                placeholder={t("client:enterPassword")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                color={error ? "failure" : undefined}
                helperText={error && <span className="font-medium">{error}</span>}
              />
              <button
                type="button"
                className="absolute right-3 top-2.5 text-gray-500 dark:text-gray-400"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <HiEyeOff className="h-5 w-5" /> : <HiEye className="h-5 w-5" />}
              </button>
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <Button color="failure" onClick={handleClose}>
              {t("common:cancel")}
            </Button>
            <Button type="submit" disabled={isLoading}>
              {t("client:setPassword")}
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
